import React, {useEffect, useRef} from 'react';
import {useNavigate} from "react-router-dom";
import styles from './unsubPopup.module.css';
import RoutesToPages from "../../RoutesToPages";

const UnsubPopup = ({isShown, messageOptions, handleShow}) => {
  const navigate = useNavigate();
  const unsubMessageClose = useRef(null);
  const messageUnsubText = useRef(null);
  const message = useRef(null);


  useEffect(() => {
    if (message.current && isShown) {
      messageUnsubText.current.textContent = messageOptions.textUnsubscription;
    }
  }, []);


  const handleVisibilityMessage = () => {
    if (message.current && isShown && messageOptions.statusUnsubscription) {
      handleShow(false);
      navigate(RoutesToPages.home)
    } else if (message.current && isShown && !messageOptions.statusUnsubscription) {
      handleShow(false);
    }
  };


  return (
    <div ref={message}
         className={`${styles.message} ${isShown ? styles.show : ''}`}>
      <div className={styles.messageContent}>
        <button ref={unsubMessageClose}
                className={styles.formClose}
                onClick={handleVisibilityMessage}
                type="button">
          close
        </button>
        <p ref={messageUnsubText}
           className={styles.messageText}>
        </p>
      </div>
    </div>
  )
}

export default UnsubPopup;